<!-- src/components/addons/DynamicMenu.vue -->
<template>
  <ul :class="listClass">
    <li
        v-for="route in visibleRoutes"
        :key="route.name"
        :class="[
          listItemClass,
          { [activeClass]: isActive(route) }
        ]"
    >
      <router-link
          :to="{ name: route.name }"
          :class="linkClass"
      >
        <font-awesome-icon
            v-if="route.meta?.icon"
            :icon="route.meta.icon"
            :class="iconClass"
        />
        <span v-if="showText" :class="textClass">{{ route.meta.title }}</span>
      </router-link>
    </li>
  </ul>
</template>

<script>
import { useRoute } from 'vue-router'
import router from '@/router'
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'DynamicMenu',
  props: {
    routes: { type: Array, default: null },
    showText: { type: Boolean, default: true },
    listClass: { type: String, default: '' },
    listItemClass: { type: String, default: '' },
    linkClass: { type: String, default: '' },
    iconClass: { type: String, default: '' },
    textClass: { type: String, default: '' },
    activeClass: { type: String, default: 'active' },
    parentRouteName: { type: String, default: null }
  },
  setup(props) {
    const route = useRoute()
    const store = useStore()
    const hasPermission = (perm) => {
      return store.getters.hasPermission(perm)
    }

    const allMenuRoutes = router.options.routes
        .filter(r => r.meta?.menu === true && r.meta?.title)

    const getNestedRoutes = () => {
      const parent = router.options.routes.find(r => r.name === props.parentRouteName)
      if (!parent) return []
      const result = []
      if (parent.children) {
        result.push(...parent.children.filter(c => c.meta?.menu === true && c.meta?.title))
      }
      return result
    }

    const sourceRoutes = computed(() => {
      if (props.routes) return props.routes
      if (props.parentRouteName) return getNestedRoutes()
      return allMenuRoutes
    })

    const visibleRoutes = computed(() => {
      return sourceRoutes.value.filter(r => {
        if (!r.meta?.permission) return true
        return hasPermission(r.meta.permission)
      })
    })

    const isActive = (routeConfig) => {
      if (!route.name) return false
      const fullRoute = router.options.routes.find(r => r.name === routeConfig.name)
      if (fullRoute?.children?.length > 0) {
        return route.name === routeConfig.name || route.name?.startsWith(`${routeConfig.name}-`)
      }
      return route.name === routeConfig.name
    }

    return { visibleRoutes, isActive }
  }
}
</script>